import PropTypes from 'prop-types';
import React from 'react';
import PromoBoxCards from '../PromoBoxCards';
import PromoBoxSlides from '../PromoBoxSlides';
import articlePropType from '../../propTypes/article';

const PromoBoxContainer = ({ promoBox, doTrackFeed }) => (
  <div>
    {promoBox.slides.length ? (
      <PromoBoxSlides promoBoxSlides={promoBox.slides} doTrackFeed={doTrackFeed} />
    ) : null}
    {promoBox.cards.length ? (
      <PromoBoxCards promoBoxCards={promoBox.cards} doTrackFeed={doTrackFeed} />
    ) : null}
  </div>
);

PromoBoxContainer.propTypes = {
  doTrackFeed: PropTypes.func.isRequired,
  promoBox: PropTypes.shape({
    cards: PropTypes.arrayOf(articlePropType).isRequired,
    slides: PropTypes.arrayOf(articlePropType).isRequired,
  }).isRequired,
};

export default PromoBoxContainer;
